import type { NextPage } from 'next';
import useUser from '../auth/useUser';
import CompanySelector from 'ui/components/companySelector/company-selector';

const Home: NextPage = () => {
  const currentUser = useUser();

  return (
    <CompanySelector
      user={currentUser}
      options={{
        gascaribe: {
          path: '/GDC',
          role: 'mensajeria_GDC',
        },
        gasguajira: {
          path: '/GDG',
          role: 'mensajeria_GDG',
        },
        efigas: {
          path: '/EFG',
          role: 'mensajeria_EFG',
        },
      }}
    />
  );
};

export default Home;
